import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailCodeBoxComponent } from '../../components/email-codebox/email-codebox.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';
import { MailgunMarkAsHtmlPipe } from '../../pipes/mailgun-mark-as-html.pipe';

@Component({
  standalone: true,
  selector: 'email-verification-url-and-code-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './verification-url-and-code.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailCodeBoxComponent,
    MailgunMarkAsHtmlPipe,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class VerificationUrlAndCodeTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<VerificationUrlAndCodeTemplateData>;
}

export type VerificationUrlAndCodeTemplateData = {
  title: string;
  avatar_url: string;
  p1: string;
  code: string;
  p2: string;
  confirm_url: string;
  confirm_label: string;
  footer: string;
  support_email: string;
};

export const VerificationUrlAndCodeTemplateMocks: VerificationUrlAndCodeTemplateData[] = [
  {
    title: 'Email verification',
    avatar_url: 'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
    p1: 'Enter this verification code to start using Recruitee.',
    code: '232564',
    confirm_url: 'http://recruitee.com',
    confirm_label: 'or simply click here to confirm.',
    p2: 'This email contains private information for your Recruitee account. Please don’t forward it or share it any other way.',
    footer: 'Need help?',
    support_email: 'support@recruitee.com',
  },
];
